<div class="modal-content">
    <div class="modal-header">
        <div class="modal-header-top-bar" fxFill fxLayout="row">
            <div fxFlex="70" fxLayoutAlign="start">
                <h3>{{modalDialogConfiguration.header | translate}}{{serviceOrderLabel}}</h3>
            </div>
            <div fxFlex="30" fxLayoutAlign="end">
                <div class="modal-close">
                    <img class="cross-close" src="/content/icons/Close-Black.svg" (click)="activeModal.close(false)">
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body" *ngIf="modalDialogConfiguration.isBody">
        <div>
            <app-task-web-details-panel [taskDataViewModel]="taskDataViewModel"></app-task-web-details-panel>
        </div>
    </div>
</div>
